angular.module('bribac.views.addIbac', [
  'ngRoute',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.entities.ibacFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.errorUtils',
  'bribac.components.ibacEditor',
  'bribac.components.ibacDetails'
])

  .config(function(
    $routeProvider,
    ROLES
  ) {
    $routeProvider.when('/add/ibac', {
      templateUrl: 'add-ibac-view.html',
      controller: 'AddIbacViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth(ROLES.SUPER_ADMIN)}}
    })
  })

  .controller('AddIbacViewCtrl', function(
    $location,
    KINDS,
    ibacFactory,
    api,
    errorUtils
  ) {

    var $ctrl = this

    $ctrl.savedEntities = []
    $ctrl.entity = ibacFactory()

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.post(KINDS.IBAC, $ctrl.entity)
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(request) {
            $ctrl.savedEntities.push(request.data)
            $ctrl.entity = ibacFactory()
            $form.$setPristine()
            $form.$setUntouched()
          },

          function error(request) {
            $form._submitError = errorUtils.parseErrorResponse(request)
          }
        )
    }

  })
